import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "filter-wrap" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", { class: "title mb-2" }, "Filter By", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = { class: "row mx-1" }
const _hoisted_8 = { class: "col-md-4 col-lg-5 col-6 px-1" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "" }, "Project", -1)
const _hoisted_11 = { class: "col-md-4 col-lg-5 col-6 px-1" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "" }, "User", -1)
const _hoisted_14 = { class: "col-md-2 col-lg-1 col-6 px-1" }
const _hoisted_15 = /*#__PURE__*/_createVNode("a", { class: "btn default-btn w-100 mt-md-4" }, "Search", -1)
const _hoisted_16 = { class: "col-md-2 col-lg-1 col-6 px-1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("a", { class: "btn red-btn w-100 mt-md-4" }, "Clear", -1)
const _hoisted_18 = {
  key: 0,
  class: "border-top py-3 note-wrap"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Phases (Tasks) are highlighted and can be conveniently viewed for the entire month using a calendar given below ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" /")
const _hoisted_22 = { class: "text-center section calendar-wrap" }
const _hoisted_23 = { class: "vuecal__cell-date" }
const _hoisted_24 = { class: "modal-wrap lg-size default-modal appointment-modal" }
const _hoisted_25 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "evendDetailsModel",
  tabindex: -1,
  "aria-labelledby": "evendDetailsModel",
  "aria-hidden": "true"
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_27 = { class: "modal-content" }
const _hoisted_28 = { class: "modal-header" }
const _hoisted_29 = { class: "modal-title" }
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "fa fa-project-diagram" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_32 = { class: "modal-body fixed-ht-div" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = /*#__PURE__*/_createVNode("i", { class: "fa fa-sitemap" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "mb-2" }
const _hoisted_39 = /*#__PURE__*/_createVNode("strong", null, "Date Range :", -1)
const _hoisted_40 = { class: "mb-2" }
const _hoisted_41 = /*#__PURE__*/_createVNode("strong", null, "Status :", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode()
const _hoisted_43 = { class: "badge badge-dim badge-success ml-1" }
const _hoisted_44 = { class: "col-md-6 text-md-right" }
const _hoisted_45 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Members :")
], -1)
const _hoisted_46 = { class: "members-list pt-0 mb-3" }
const _hoisted_47 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_48 = { class: "more-member" }
const _hoisted_49 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Phase Description :")
], -1)
const _hoisted_50 = { class: "mb-2" }
const _hoisted_51 = { class: "mt-4" }
const _hoisted_52 = /*#__PURE__*/_createVNode("strong", null, "No of Tasks :", -1)
const _hoisted_53 = {
  key: 0,
  class: "row"
}
const _hoisted_54 = { class: "shadowed-card bg-white mb-2 p-2 project-body my-3" }
const _hoisted_55 = { class: "mb-0" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fa fa-tasks" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_58 = { class: "mb-2" }
const _hoisted_59 = /*#__PURE__*/_createVNode("strong", null, "Date Range :", -1)
const _hoisted_60 = { class: "mb-2" }
const _hoisted_61 = /*#__PURE__*/_createVNode("strong", null, "Status :", -1)
const _hoisted_62 = /*#__PURE__*/_createTextVNode()
const _hoisted_63 = { class: "badge badge-dim badge-success ml-1" }
const _hoisted_64 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Task Description :")
], -1)
const _hoisted_65 = { class: "mb-2" }
const _hoisted_66 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Members :")
], -1)
const _hoisted_67 = { class: "members-list pt-0" }
const _hoisted_68 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_69 = { class: "more-member" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn secondary-btn",
    "data-dismiss": "modal"
  }, " Close ")
], -1)
const _hoisted_71 = { class: "modal-wrap lg-size default-modal appointment-modal" }
const _hoisted_72 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "evendListModel",
  tabindex: -1,
  "aria-labelledby": "evendListModel",
  "aria-hidden": "true"
}
const _hoisted_73 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_74 = { class: "modal-content" }
const _hoisted_75 = { class: "modal-header" }
const _hoisted_76 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-project-diagram" }),
  /*#__PURE__*/_createTextVNode("All phase ")
], -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_78 = { class: "title" }
const _hoisted_79 = /*#__PURE__*/_createVNode("i", { class: "fa fa-sitemap" }, null, -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "mb-2" }
const _hoisted_84 = /*#__PURE__*/_createVNode("strong", null, "Date Range :", -1)
const _hoisted_85 = { class: "mb-2" }
const _hoisted_86 = /*#__PURE__*/_createVNode("strong", null, "Status :", -1)
const _hoisted_87 = /*#__PURE__*/_createTextVNode()
const _hoisted_88 = { class: "badge badge-dim badge-success ml-1" }
const _hoisted_89 = { class: "col-md-6 text-md-right" }
const _hoisted_90 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Members :")
], -1)
const _hoisted_91 = { class: "members-list pt-0 mb-3" }
const _hoisted_92 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_93 = { class: "more-member" }
const _hoisted_94 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Phase Description :")
], -1)
const _hoisted_95 = { class: "mb-2" }
const _hoisted_96 = { class: "mt-4" }
const _hoisted_97 = /*#__PURE__*/_createVNode("strong", null, "No of Tasks :", -1)
const _hoisted_98 = {
  key: 0,
  class: "row"
}
const _hoisted_99 = { class: "shadowed-card bg-white mb-2 p-2 project-body my-3" }
const _hoisted_100 = { class: "mb-0" }
const _hoisted_101 = /*#__PURE__*/_createVNode("i", { class: "fa fa-tasks" }, null, -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_103 = { class: "mb-2" }
const _hoisted_104 = /*#__PURE__*/_createVNode("strong", null, "Date Range :", -1)
const _hoisted_105 = { class: "mb-2" }
const _hoisted_106 = /*#__PURE__*/_createVNode("strong", null, "Status :", -1)
const _hoisted_107 = /*#__PURE__*/_createTextVNode()
const _hoisted_108 = { class: "badge badge-dim badge-success ml-1" }
const _hoisted_109 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Task Description :")
], -1)
const _hoisted_110 = { class: "mb-2" }
const _hoisted_111 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "Members :")
], -1)
const _hoisted_112 = { class: "members-list pt-0" }
const _hoisted_113 = {
  key: 0,
  href: "javascript:void(0)"
}
const _hoisted_114 = { class: "more-member" }
const _hoisted_115 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn secondary-btn",
    "data-dismiss": "modal"
  }, " Close ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_vue_cal = _resolveComponent("vue-cal")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getAllAppointments)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_multiselect, {
                modelValue: _ctx.selectedOptions,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedOptions = $event)),
                "tag-placeholder": "select project",
                placeholder: "Select Project",
                label: "name",
                "track-by": "code",
                options: _ctx.options,
                multiple: true
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_multiselect, {
                modelValue: _ctx.selectedUserOptions,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedUserOptions = $event)),
                "tag-placeholder": "select user",
                placeholder: "Select User",
                label: "name",
                "track-by": "code",
                options: _ctx.userOptions,
                multiple: false
              }, null, 8, ["modelValue", "options"])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", {
              class: "mt-1",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.serachData && _ctx.serachData(...args)))
            }, [
              _hoisted_15
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", {
              class: "mt-1",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearData && _ctx.clearData(...args)))
            }, [
              _hoisted_17
            ])
          ])
        ]),
        (_ctx.state.data.todoInMonthe.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.todoInMonthe, (phase, phaseIndex) => {
                return (_openBlock(), _createBlock("strong", { key: phaseIndex }, [
                  _createVNode("a", {
                    onClick: ($event: any) => (_ctx.gotoMonth(phase))
                  }, _toDisplayString(phase), 9, ["onClick"]),
                  _hoisted_21
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode(_component_vue_cal, {
        id: "vueCalenderAppointmentList",
        "disable-views": ['week'],
        "active-view": "month",
        "events-count-on-year-view": "",
        "events-on-month-view": "short",
        "show-all-day-events": ['short', true, false][_ctx.state.data.showAllDayEvents],
        events: _ctx.state.data.appointmentList,
        height: 400,
        "selected-date": _ctx.state.data.selectedDate,
        scrollToToday: true,
        "on-event-click": _ctx.openEventDetails,
        onViewChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeMonthData($event))),
        style: {"height":"77vh"}
      }, _createSlots({
        event: _withCtx(({ event }) => [
          _createVNode("div", {
            class: "event-content",
            style: { backgroundColor: event.backgroundColor, color: event.color }
          }, [
            _createVNode("div", {
              class: "vuecal__event-title",
              innerHTML: event.title
            }, null, 8, ["innerHTML"])
          ], 4)
        ]),
        _: 2
      }, [
        (_ctx.isMonthView)
          ? {
              name: "cell-content",
              fn: _withCtx(({ cell, events }) => [
                _createVNode("div", _hoisted_23, _toDisplayString(cell.content), 1),
                (events.length > _ctx.state.data.eventLimit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "more",
                      onClick: ($event: any) => (_ctx.phaseList(events))
                    }, "+" + _toDisplayString(events.length -
            _ctx.state.data.eventLimit) + " More Phases", 9, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            }
          : undefined
      ]), 1032, ["show-all-day-events", "events", "selected-date", "on-event-click"])
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("h5", _hoisted_29, [
                _hoisted_30,
                _createTextVNode(" " + _toDisplayString(_ctx.state.data.selectedEventValue.project), 1)
              ]),
              _createVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeShowDataModel && _ctx.closeShowDataModel(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_31
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("h1", _hoisted_33, [
                _hoisted_34,
                _createTextVNode(" " + _toDisplayString(_ctx.state.data.selectedEventValue.phase), 1)
              ]),
              _hoisted_35,
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("p", _hoisted_38, [
                    _hoisted_39,
                    _createVNode("small", null, _toDisplayString(_ctx.state.data.startDate) + " - " + _toDisplayString(_ctx.state.data.endDate), 1)
                  ]),
                  _createVNode("p", _hoisted_40, [
                    _hoisted_41,
                    _hoisted_42,
                    _createVNode("span", _hoisted_43, _toDisplayString(_ctx.state.data.status), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("div", _hoisted_46, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedEventValue.user.slice(0, 3), (member, memberIndex) => {
                      return (_openBlock(), _createBlock("a", {
                        href: "javascript:void(0)",
                        key: memberIndex
                      }, [
                        _createVNode("span", null, [
                          (member.image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: member.image,
                                alt: "",
                                title: `${member.full_name}` +
                          '(' +
                          `${member.email}` +
                          ')'
                        
                              }, null, 8, ["src", "title"]))
                            : (_openBlock(), _createBlock("img", {
                                key: 1,
                                src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg',
                                alt: "",
                                title: `${member.full_name}` + '(' + `${member.email}` + ')'
                              }, null, 8, ["src", "title"]))
                        ])
                      ]))
                    }), 128)),
                    (_ctx.state.data.selectedEventValue.user.length > 3)
                      ? (_openBlock(), _createBlock("a", _hoisted_47, [
                          _createVNode("span", _hoisted_48, "+" + _toDisplayString(_ctx.state.data.selectedEventValue.user.length - 3), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_49,
              _createVNode("p", _hoisted_50, _toDisplayString(_ctx.state.data.details), 1),
              _createVNode("p", _hoisted_51, [
                _hoisted_52,
                _createTextVNode(_toDisplayString(_ctx.state.data.selectedEventValue.task.length), 1)
              ]),
              (_ctx.state.data.selectedEventValue.task)
                ? (_openBlock(), _createBlock("div", _hoisted_53, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedEventValue.task, (task, taskIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-6",
                        key: taskIndex
                      }, [
                        _createVNode("div", _hoisted_54, [
                          _createVNode("h5", _hoisted_55, [
                            _hoisted_56,
                            _createTextVNode(" " + _toDisplayString(task.name), 1)
                          ]),
                          _hoisted_57,
                          _createVNode("p", _hoisted_58, [
                            _hoisted_59,
                            _createVNode("small", null, _toDisplayString(_ctx.changeDateFormate(task.start_date)) + " - " + _toDisplayString(_ctx.changeDateFormate(task.end_date)), 1)
                          ]),
                          _createVNode("p", _hoisted_60, [
                            _hoisted_61,
                            _hoisted_62,
                            _createVNode("span", _hoisted_63, _toDisplayString(task.status), 1)
                          ]),
                          _hoisted_64,
                          _createVNode("p", _hoisted_65, _toDisplayString(task.description), 1),
                          _hoisted_66,
                          _createVNode("div", _hoisted_67, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers.slice(
                        0,
                        3
                      ), (member, memberIndex) => {
                              return (_openBlock(), _createBlock("a", {
                                href: "javascript:void(0)",
                                key: memberIndex
                              }, [
                                _createVNode("span", null, [
                                  (member.image)
                                    ? (_openBlock(), _createBlock("img", {
                                        key: 0,
                                        src: member.image,
                                        alt: "",
                                        title: `${member.full_name}` +
                            '(' +
                            `${member.email}` +
                            ')'
                          
                                      }, null, 8, ["src", "title"]))
                                    : (_openBlock(), _createBlock("img", {
                                        key: 1,
                                        src: _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                            : 'img/no-user.jpg'
                          ,
                                        alt: "",
                                        title: `${member.full_name}` + '(' + `${member.email}` + ')'
                                      }, null, 8, ["src", "title"]))
                                ])
                              ]))
                            }), 128)),
                            (task.allMembers.length > 3)
                              ? (_openBlock(), _createBlock("a", _hoisted_68, [
                                  _createVNode("span", _hoisted_69, "+" + _toDisplayString(task.allMembers.length - 3), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_70
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_71, [
      _createVNode("div", _hoisted_72, [
        _createVNode("div", _hoisted_73, [
          _createVNode("div", _hoisted_74, [
            _createVNode("div", _hoisted_75, [
              _hoisted_76,
              _createVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeListDataModel && _ctx.closeListDataModel(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_77
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.allPhases, (phase, phaseIndex) => {
              return (_openBlock(), _createBlock("div", {
                class: "modal-body fixed-ht-div",
                key: phaseIndex
              }, [
                _createVNode("h1", _hoisted_78, [
                  _hoisted_79,
                  _createTextVNode(" (" + _toDisplayString(phase.contentFull.todo.project.name) + ">" + _toDisplayString(phase.contentFull.name) + ")", 1)
                ]),
                _hoisted_80,
                _createVNode("div", _hoisted_81, [
                  _createVNode("div", _hoisted_82, [
                    _createVNode("p", _hoisted_83, [
                      _hoisted_84,
                      _createVNode("small", null, _toDisplayString(_ctx.changeDateFormate(phase.contentFull.start_date)) + " - " + _toDisplayString(_ctx.changeDateFormate(phase.contentFull.end_date)), 1)
                    ]),
                    _createVNode("p", _hoisted_85, [
                      _hoisted_86,
                      _hoisted_87,
                      _createVNode("span", _hoisted_88, _toDisplayString(phase.contentFull.status), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _createVNode("div", _hoisted_91, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.contentFull.allMembers.slice(0, 3), (member, memberIndex) => {
                        return (_openBlock(), _createBlock("a", {
                          href: "javascript:void(0)",
                          key: memberIndex
                        }, [
                          _createVNode("span", null, [
                            (member.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.image,
                                  alt: "",
                                  title: `${member.full_name}` +
                          '(' +
                          `${member.email}` +
                          ')'
                        
                                }, null, 8, ["src", "title"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: _ctx.state.data.imageBaseUrl
                          ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                          : 'img/no-user.jpg',
                                  alt: "",
                                  title: `${member.full_name}` + '(' + `${member.email}` + ')'
                                }, null, 8, ["src", "title"]))
                          ])
                        ]))
                      }), 128)),
                      (phase.contentFull.allMembers.length > 3)
                        ? (_openBlock(), _createBlock("a", _hoisted_92, [
                            _createVNode("span", _hoisted_93, "+" + _toDisplayString(phase.contentFull.allMembers.length - 3), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _hoisted_94,
                _createVNode("p", _hoisted_95, _toDisplayString(phase.contentFull.details), 1),
                _createVNode("p", _hoisted_96, [
                  _hoisted_97,
                  _createTextVNode(_toDisplayString(phase.contentFull.tasks.length), 1)
                ]),
                (phase.contentFull.tasks)
                  ? (_openBlock(), _createBlock("div", _hoisted_98, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.contentFull.tasks, (task, taskIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "col-md-6",
                          key: taskIndex
                        }, [
                          _createVNode("div", _hoisted_99, [
                            _createVNode("h5", _hoisted_100, [
                              _hoisted_101,
                              _createTextVNode(" " + _toDisplayString(task.name), 1)
                            ]),
                            _hoisted_102,
                            _createVNode("p", _hoisted_103, [
                              _hoisted_104,
                              _createVNode("small", null, _toDisplayString(_ctx.changeDateFormate(task.start_date)) + " - " + _toDisplayString(_ctx.changeDateFormate(task.end_date)), 1)
                            ]),
                            _createVNode("p", _hoisted_105, [
                              _hoisted_106,
                              _hoisted_107,
                              _createVNode("span", _hoisted_108, _toDisplayString(task.status), 1)
                            ]),
                            _hoisted_109,
                            _createVNode("p", _hoisted_110, _toDisplayString(task.description), 1),
                            _hoisted_111,
                            _createVNode("div", _hoisted_112, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.allMembers.slice(
                        0,
                        3
                      ), (member, memberIndex) => {
                                return (_openBlock(), _createBlock("a", {
                                  href: "javascript:void(0)",
                                  key: memberIndex
                                }, [
                                  _createVNode("span", null, [
                                    (member.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          src: member.image,
                                          alt: "",
                                          title: `${member.full_name}` +
                            '(' +
                            `${member.email}` +
                            ')'
                          
                                        }, null, 8, ["src", "title"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                            : 'img/no-user.jpg'
                          ,
                                          alt: "",
                                          title: `${member.full_name}` + '(' + `${member.email}` + ')'
                                        }, null, 8, ["src", "title"]))
                                  ])
                                ]))
                              }), 128)),
                              (task.allMembers.length > 3)
                                ? (_openBlock(), _createBlock("a", _hoisted_113, [
                                    _createVNode("span", _hoisted_114, "+" + _toDisplayString(task.allMembers.length - 3), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _hoisted_115
          ])
        ])
      ])
    ])
  ]))
}